import { loadGoogleFont } from '../../base/base';

import { $ } from 'base/bootstrap';

loadGoogleFont(['Overpass:300,400,700,900']);

$('.datepicker#birthday').datepicker({
    format: 'dd/mm/yyyy',
    defaultViewDate: { year: 1990, month: 0, day: 1 },
});
